import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const features = ["Unlimited Locations", "Unlimited Menus", "Choose your theme", "Support in getting started", "30 day money back guarantee"];

const Pricing = () => {
  return (
    <div className='mt-14 bg-white flex items-center justify-center'>
      <Helmet>
        <title>Pricing — Monthly &amp; Annual Plans | tastebud.ee</title>
        <meta name='description' content='Choose monthly at £5 or save 50% with our annual plan at £30 per year. All plans include unlimited locations, menus and QR codes for your market stall.' />
        <link rel='canonical' href='https://tastebud.ee/pricing' />
      </Helmet>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "tastebud.ee Subscription",
            "description": "QR code allergen menus for UK market stalls and street food vendors. Unlimited locations, menus and QR codes.",
            "url": "https://tastebud.ee/pricing",
            "brand": { "@type": "Brand", "name": "tastebud.ee" },
            "offers": [
              {
                "@type": "Offer",
                "name": "Monthly Plan",
                "price": "5.00",
                "priceCurrency": "GBP",
                "priceSpecification": { "@type": "UnitPriceSpecification", "price": "5.00", "priceCurrency": "GBP", "unitText": "month" },
                "url": "https://tastebud.ee/account/subscription",
              },
              {
                "@type": "Offer",
                "name": "Annual Plan",
                "price": "30.00",
                "priceCurrency": "GBP",
                "priceSpecification": { "@type": "UnitPriceSpecification", "price": "30.00", "priceCurrency": "GBP", "unitText": "year" },
                "url": "https://tastebud.ee/account/subscription",
              },
            ],
          }),
        }}
      />
      <div className='px-6 max-w-screen-md w-full'>
        <h1 className='text-xl font-bold mb-4'>Pricing</h1>
        <p className='mb-6'>Choose the plan that works for you — all plans include every feature. Pay monthly for flexibility, or save 50% by paying annually.</p>

        <div className='p-2 md:p-0 grid grid-cols-1 md:grid-cols-2 gap-6 justify-items-center'>
          {/* Monthly */}
          <div className='bg-white border-gray-50 shadow-2xl shadow-gray-400 w-72'>
            <div className='border-b-gray-800 border-b p-6 bg-[#7BC043]'>
              <h2 className='text-lg font-bold'>Monthly</h2>
              <p className='text-sm'>Pay as you go.</p>
            </div>
            <div className='px-6 py-3'>
              <h3 className='text-xl font-light py-2'>
                <span className='text-3xl'>£5.00</span> / month
              </h3>
              <p className='uppercase text-sm text-gray-600 pt-4'>Includes:</p>
              <ul className='list-disc list-inside mt-2 ml-4 text-sm leading-6 text-gray-600'>
                {features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Annual */}
          <div className='bg-white border-gray-50 shadow-2xl shadow-gray-400 w-72'>
            <div className='border-b-gray-800 border-b p-6 bg-yellow-400 flex items-start justify-between'>
              <div>
                <h2 className='text-lg font-bold'>Annual</h2>
                <p className='text-sm'>Best value.</p>
              </div>
              <span className='bg-black text-yellow-400 text-xs font-bold px-2 py-1 rounded'>Save 50%</span>
            </div>
            <div className='px-6 py-3'>
              <h3 className='text-xl font-light py-2'>
                <span className='text-3xl'>£30.00</span> / year
              </h3>
              <p className='uppercase text-sm text-gray-600 pt-4'>Includes:</p>
              <ul className='list-disc list-inside mt-2 ml-4 text-sm leading-6 text-gray-600'>
                {features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className='mt-10 flex flex-col items-center'>
          <Link to='/account/register'>
            <button className='text-[#FFC701] bg-black rounded-xl font-bold px-6 py-3'>Start your 30-day free trial</button>
          </Link>
          <p className='mt-3 text-center text-sm text-gray-600'>No credit card required for free trial</p>
        </div>
        <p className='m-10 text-center'>Please get in touch if you would like to discuss custom packages and pricing.</p>
      </div>
    </div>
  );
};

export default Pricing;
